import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles, Grid } from '@material-ui/core';
import { FHEContainer, FHEButton } from 'data/components';
import { Toastr } from 'data/common';
import { TableHomeProducts } from '../tables';
import { getProductsByHomeId, deleteProduct } from '../../../data/Products/actions';
import selectors from '../selectors';

class HomeProducts extends PureComponent {
    static propTypes = {
        deleteProduct: PropTypes.func.isRequired,
        getProductsByHomeId: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired,
        isActive: PropTypes.bool,
        productsInitialized: PropTypes.bool.isRequired,
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        homeId: PropTypes.string.isRequired,
        homeBoxMac: PropTypes.string.isRequired
    };

    static defaultProps = {
        isActive: true
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: props.isActive,
            needGetData: props.isActive,
            fetching: false,
            initialized: false,
            error: null,
            tableKey: false
        };
    }
    static getDerivedStateFromProps(props, state) {
        const { needGetData, loading, error, fetching, initialized, tableKey } = state;
        const { isActive, productsInitialized } = props;
        if (!productsInitialized && isActive && !needGetData && !loading && !error && !fetching && !initialized)
            return { needGetData: true, loading: true };
        if (isActive && !tableKey) return { tableKey: true };

        return null;
    }
    componentDidMount() {
        const { needGetData } = this.state;
        if (needGetData) this.getProducts();
    }

    componentDidUpdate() {
        const { isActive, productsInitialized } = this.props;
        const { needGetData, fetching, error } = this.state;

        if (!productsInitialized && isActive && needGetData && !fetching && !error) {
            this.getProducts();
        }
    }

    getProducts = () => {
        const { getProductsByHomeId, homeId } = this.props;
        this.state.fetching = true;
        getProductsByHomeId(homeId)
            .then(() => {
                this.setState({
                    error: null,
                    loading: false,
                    fetching: false,
                    needGetData: false,
                    initialized: true
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({ error: message, loading: false, needGetData: false, fetching: false });
            });
    };

    retryGetData = () => {
        this.setState({ error: null, loading: true, needGetData: true });
    };
    addProduct = () => {
        const { history, homeBoxMac } = this.props;
        return history.push({ pathname: '/fhe/products/add', state: { boxMac: homeBoxMac } });
    };

    deletingProduct = (productType, identifier, type, callbackRowActionLoading) => {
        const { deleteProduct, homeId } = this.props;
        deleteProduct(homeId, productType, identifier, type)
            .then(() => {
                Toastr.success(Translator.translate(`generic.products.actions.deleteProductSuccess`));
            })
            .catch(err => {
                const message = Translator.translateWithFallback(
                    `api.message.${err.message ? err.message : err}`,
                    'generic.products.actions.deleteProductError'
                );
                Toastr.error(message);
            })
            .finally(() => {
                callbackRowActionLoading(false);
            });
    };

    deleteProduct = (rowData, callbackRowActionLoading) => {
        callbackRowActionLoading(true);
        Toastr.confirm(
            Translator.translate('generic.products.actions.confirmationDeleteProduct', rowData.label),
            Translator.translate('generic.products.actions.confirmationDeleteProductTitle'),
            {
                onYes: () => {
                    this.deletingProduct(rowData.productType, rowData.productIdentifier, rowData.id, callbackRowActionLoading);
                },
                onNo: () => {
                    callbackRowActionLoading(false);
                }
            }
        );
    };

    renderChildren = () => {
        const { tableKey } = this.state;
        const { classes, profile, homeBoxMac, history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        return (
            <Fragment>
                {(profile.get('admin') ||
                    (userRights.includes('addProduct') &&
                        (userRights.includes('addProduct_fhe_product') ||
                            userRights.includes('addProduct_heat_and_cool') ||
                            userRights.includes('addProduct_smart_plug') ||
                            userRights.includes('addProduct_sensor') ||
                            userRights.includes('addProduct_drive_elec')))) && (
                    <Grid container justify="center" alignItems="center">
                        <Grid container item sm={12} md={6} xl={3} justify="center" alignItems="center" direction="column">
                            <FHEButton
                                disabled={!homeBoxMac}
                                tooltip={
                                    !homeBoxMac
                                        ? Translator.translate(
                                              'generic.products.addProduct.tooltip',
                                              Translator.translate(`${history.environment}.centerName`)
                                          )
                                        : null
                                }
                                className={classes.button}
                                content={Translator.translate('generic.products.addProduct.action')}
                                clickFunction={this.addProduct}
                            />
                        </Grid>
                    </Grid>
                )}
                <TableHomeProducts key={tableKey} deleteProduct={this.deleteProduct} />
            </Fragment>
        );
    };

    render() {
        const { error, loading } = this.state;
        const { productsInitialized } = this.props;

        return (
            <FHEContainer
                hasNoClassContainer
                loading={loading && !productsInitialized}
                error={error}
                onClickFunc={this.retryGetData}
                onRender={this.renderChildren}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const homeId = props.match.params.homeId;
    return {
        profile: selectors.getProfile(state),
        homeId: homeId,
        productsInitialized: selectors.getHomeByHomeId(state, homeId).getIn(['productsInitialized'], false),
        homeBoxMac: selectors.getBoxByHomeId(state, homeId).getIn(['macAddress'], '')
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getProductsByHomeId, deleteProduct }, dispatch)
    )(withStyles(styles, { withTheme: true })(HomeProducts))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Home/sections/HomeProducts.js